import { useLocation, useNavigate } from "react-router-dom"

import { PlusIcon } from "@radix-ui/react-icons"

import { GetCompanySalons } from "@/company_admin/pages/company_admin/CompanyAdmin"
import SalonSelect from "@/lib/components/SalonSelect/SalonSelect"
import { useMe } from "@/lib/graphql/me"
import useSwitchSalon from "@/lib/graphql/useSwitchSalon"
import hamburger from "@/lib/images/hamburger.svg"
import logo from "@/lib/images/logo.svg"
import useLogout from "@/main/components/common_features/salon/useLogout"
import { useMediaQueryContext } from "@/provider/MediaQueryProvider"
import { useCompanyAdminQuery } from "@/provider/apollo/Apollo"
import "./Sidebar.scss"

type Props = {
	email: string
	onClickHamburger: () => void
}

const Sidebar = ({ email, onClickHamburger }: Props) => {
	const navigate = useNavigate()
	const location = useLocation()
	const { isMobile } = useMediaQueryContext()
	const { salons } = useMe()
	const switchSalon = useSwitchSalon()
	const logout = useLogout()
	const onClickLogout = (e) => {
		e.preventDefault()
		logout().then(() => {
			window.location.reload()
		})
	}
	const { data: companySalonsData } = useCompanyAdminQuery(GetCompanySalons, {
		variables: { param: {} },
		errorPolicy: "all",
		context: { disableErrorDialog: true }, // company admin 権限ない場合はエラーになってOKなので
	})
	const companyName = companySalonsData?.getCompanySalons?.companyName ?? ""
	const isCouponMasterPath =
		location.pathname === "/coupon_masters" ||
		location.pathname === "/coupon_masters/new"

	return (
		<div className="sidebar">
			<div className="hamburger_container">
				<img
					src={hamburger}
					alt="Hamburger"
					width={30}
					height={30}
					className="hamburger"
					onClick={onClickHamburger}
				/>
			</div>
			{!isMobile && (
				<div className="sidebar__header">
					<img src={logo} alt="Logo" className="sidebar__logo" />
				</div>
			)}

			{salons && <SalonSelect salons={salons} onChangeSalon={switchSalon} />}

			<ul className="sidebar__index">
				<li
					className="sidebar__new_cancel_button_container"
					onClick={() => navigate("/new_cancel")}
				>
					<PlusIcon />
					キャンセル情報作成
				</li>
				<li
					className={`sidebar__index-elm ${
						location.pathname === "/" ? "sidebar__active" : ""
					}`}
					onClick={() => {
						navigate("/")
					}}
				>
					<a>ホーム</a>
				</li>
				<li
					className={`sidebar__index-elm ${
						isCouponMasterPath ? "sidebar__active" : ""
					}`}
					onClick={() => {
						navigate("/coupon_masters")
					}}
				>
					<a>特典</a>
				</li>
				<li
					className={`sidebar__index-elm ${
						location.pathname === "/claim_rule" ? "sidebar__active" : ""
					}`}
					onClick={() => {
						navigate("/claim_rule")
					}}
				>
					<a>請求ルール</a>
				</li>
				<li
					className={`sidebar__index-elm ${
						location.pathname === "/salon_settings" ? "sidebar__active" : ""
					}`}
					onClick={() => {
						navigate("/salon_settings")
					}}
				>
					<a>店舗設定</a>
				</li>
				{companyName && (
					<li
						className={`sidebar__index-elm ${
							location.pathname === "/company_admin" ? "sidebar__active" : ""
						}`}
						onClick={() => {
							navigate("/company_admin")
						}}
					>
						<a>会社・経理ページ</a>
					</li>
				)}
				<li>
					<a
						href="https://refundhub-help.notion.site/RefundHub-ad994c70cc064210b3b6b70a8485a01e"
						target="_blank"
						rel="noreferrer"
					>
						ヘルプページ
					</a>
				</li>
			</ul>

			<div className="sidebar__footer">
				<p>{email}</p>
				<a href="/" onClick={onClickLogout} className="sidebar__logout">
					ログアウト
				</a>
			</div>
		</div>
	)
}

export default Sidebar
